/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PostAccountSettingsItemAddress,
    PostAccountSettingsItemAddressFromJSON,
    PostAccountSettingsItemAddressFromJSONTyped,
    PostAccountSettingsItemAddressToJSON,
} from './PostAccountSettingsItemAddress';
import {
    PostAccountSettingsItemMediaInformation,
    PostAccountSettingsItemMediaInformationFromJSON,
    PostAccountSettingsItemMediaInformationFromJSONTyped,
    PostAccountSettingsItemMediaInformationToJSON,
} from './PostAccountSettingsItemMediaInformation';

/**
 * 
 * @export
 * @interface PostAccountSettingsItem
 */
export interface PostAccountSettingsItem {
    /**
     * 名前（性）
     * @type {string}
     * @memberof PostAccountSettingsItem
     */
    firstName: string;
    /**
     * 名前（名）
     * @type {string}
     * @memberof PostAccountSettingsItem
     */
    lastName: string;
    /**
     * 企業名
     * @type {string}
     * @memberof PostAccountSettingsItem
     */
    companyName: string;
    /**
     * 
     * @type {PostAccountSettingsItemAddress}
     * @memberof PostAccountSettingsItem
     */
    address?: PostAccountSettingsItemAddress;
    /**
     * 電話番号
     * @type {string}
     * @memberof PostAccountSettingsItem
     */
    phoneNumber: string;
    /**
     * FAX番号
     * @type {string}
     * @memberof PostAccountSettingsItem
     */
    faxNumber?: string;
    /**
     * 媒体情報リスト
     * @type {Array<PostAccountSettingsItemMediaInformation>}
     * @memberof PostAccountSettingsItem
     */
    mediaInformation: Array<PostAccountSettingsItemMediaInformation>;
    /**
     * ヘッドラインメール受信するか
     * @type {boolean}
     * @memberof PostAccountSettingsItem
     */
    isReceiveHeadlineEmail: boolean;
    /**
     * 個別プレスリリースメール受信するか
     * @type {boolean}
     * @memberof PostAccountSettingsItem
     */
    isReceivePressReleaseEmail: boolean;
    /**
     * HTMLメール受信するか
     * @type {boolean}
     * @memberof PostAccountSettingsItem
     */
    isReceiveHtmlEmail: boolean;
    /**
     * 最適化メール受信するか
     * @type {boolean}
     * @memberof PostAccountSettingsItem
     */
    isReceiveOptimizedEmail: boolean;
    /**
     * エイプリルフール・エイプリルドリームメール受信するか
     * @type {boolean}
     * @memberof PostAccountSettingsItem
     */
    isAprilFoolAndAprilDreamEmail: boolean;
}

export function PostAccountSettingsItemFromJSON(json: any): PostAccountSettingsItem {
    return PostAccountSettingsItemFromJSONTyped(json, false);
}

export function PostAccountSettingsItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostAccountSettingsItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'companyName': json['company_name'],
        'address': !exists(json, 'address') ? undefined : PostAccountSettingsItemAddressFromJSON(json['address']),
        'phoneNumber': json['phone_number'],
        'faxNumber': !exists(json, 'fax_number') ? undefined : json['fax_number'],
        'mediaInformation': ((json['media_information'] as Array<any>).map(PostAccountSettingsItemMediaInformationFromJSON)),
        'isReceiveHeadlineEmail': json['is_receive_headline_email'],
        'isReceivePressReleaseEmail': json['is_receive_press_release_email'],
        'isReceiveHtmlEmail': json['is_receive_html_email'],
        'isReceiveOptimizedEmail': json['is_receive_optimized_email'],
        'isAprilFoolAndAprilDreamEmail': json['is_april_fool_and_april_dream_email'],
    };
}

export function PostAccountSettingsItemToJSON(value?: PostAccountSettingsItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first_name': value.firstName,
        'last_name': value.lastName,
        'company_name': value.companyName,
        'address': PostAccountSettingsItemAddressToJSON(value.address),
        'phone_number': value.phoneNumber,
        'fax_number': value.faxNumber,
        'media_information': ((value.mediaInformation as Array<any>).map(PostAccountSettingsItemMediaInformationToJSON)),
        'is_receive_headline_email': value.isReceiveHeadlineEmail,
        'is_receive_press_release_email': value.isReceivePressReleaseEmail,
        'is_receive_html_email': value.isReceiveHtmlEmail,
        'is_receive_optimized_email': value.isReceiveOptimizedEmail,
        'is_april_fool_and_april_dream_email': value.isAprilFoolAndAprilDreamEmail,
    };
}

